 <template>
  <div class="box4">
    <pageTitle title="院校介绍"/>
    <div class="text text1">夏威夷太平洋大学(Hawai'i Pacific University，简称HPU)成立于1965年，是位于美国夏威夷州檀香山市的综合型非盈利性质私立大学。全球共有四个校区，主校区坐落于檀香山市中心，毗邻夏威夷州政府与市政厅。檀香山市是美国夏威州首府和港口城市，太平洋地区的商业金融中心。此地区拥有全球增长最快速的经济环境，能为学生提供在国际性的环境下接受多元化教育的机会。</div>
    <div class="text text2">该校优势专业侧重于商学、文理学，尤其在商业方面有着杰出的表现，是全美最有发展性的大学之一。(WASC)认证夏威夷太平洋大学获得了美国西部院校联盟中国教育部认证备案。</div>
    <div class="main-box">
      
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      
    };
  },
  
};
</script>

<style lang="less" scoped>
.box4 {
  padding: 80px 0;
  width:100%;
  background: url("../../../assets/coursePage/hawai/box4/bg.png") no-repeat;
  background-size: 100% auto;
  /deep/.course-title-box .course-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #092A52;
    line-height: 64px;
    text-align: center;
  }
  .text {
    padding: 0 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #092A52;
    line-height: 44px;
    text-align: justify;
  }
  .text1 {
    margin-top: 48px;
  }
  // .text2 {
  //   margin-top: 8px;
  // }
  .main-box {
    margin: 38px auto 0;
    width: 674px;
    height: 604px;
    background: url("../../../assets/coursePage/hawai/box4/main.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
